import API from 'services/api';
import { fetchWithRetry } from 'services/fetchWithRetry';

class AuditService {
    private readonly getAuditURL = `/audit/logs`;
    private readonly exportAuditURL = `/export/audit-logs`;
    // ---------------------------------------------------------------

    getAudit(params: {
        size: number;
        page: number;
        username: string;
        actionType: string;
        entityType: string;
        status: string;
        ipAddress: string;
        entityId: string;
        startDate: string;
        endDate: string;
    }) {
        return fetchWithRetry(API.get(this.getAuditURL, { params }));
    }

    exportAudit(startDate: string, endDate: string, username: string, actionType: string) {
        return fetchWithRetry(
            API.post(this.exportAuditURL, {
                startDate,
                endDate,
                username,
                actionType,
            })
        );
    }
}

export default new AuditService();
